import clsx from 'clsx';
import { CheckmarkCircle02Icon } from 'hugeicons-react';
import PropTypes from 'prop-types';

export default function SubHeading({ children, className, showIcon = true }) {
  return (
    <div className="bg-event-deep/70 p-3 rounded-lg shadow-sm">
      <div className="grid grid-cols-[auto_1fr] gap-1 items-center">
        {showIcon && (
          <div className="flex-shrink-0 bg-event-icon-background/70 p-2 rounded-full">
            <CheckmarkCircle02Icon size={38} className="text-corporate-light" />
          </div>
        )}
        <div className={!showIcon ? 'col-span-2' : ''}>
          <p className={clsx('text-corporate-gray text-base font-medium font-sans break-words', className)}>
            {children}
          </p>
        </div>
      </div>
    </div>
  );
}

SubHeading.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
